import vue from 'vue';
import vueRouter from 'vue-router';
import Guard from './Guard';

vue.use(vueRouter);

// Page components
import { LoginPage } from '../components/pages/login-page';
import { CertificateApplication } from '../components/pages/certificate-application';
import { ChangePassword } from '../components/pages/change-password';
import { CoursePage } from '../components/pages/course-page';
import { LessonPage } from '../components/pages/lesson-page';
import { Extendcourse } from '../components/pages/extend-course';
import { Upgradecourse } from '../components/pages/upgrade-course';
import { LibraryPage } from '../components/pages/library-page';
import { FinishPage } from '../components/pages/finish-course';
import { MarksPage } from '../components/pages/marks-page';
import { ProfilePage } from '../components/pages/profile-page';
import { QuizPage } from '../components/pages/quiz-page';
import { PageNotFound } from '../components/pages/page-not-found';
import { ResetPasswordPage } from '../components/pages/reset-password-page';
import { NewPasswordPage } from '../components/pages/new-password-page';
// import { CheckoutPage } from '../components/pages/checkout-page';
import { CheckoutPageStripe } from '../components/pages/checkout-page-stripe';
// import { CheckoutPagePaypal } from '../components/pages/checkout-page-paypal';
import { CertificateVerification } from '../components/pages/certificate-verification-page';
import { PracticumPage } from '../components/pages/practicum-page';

export default new vueRouter({
  mode: 'history',
  base: process.env.PATH_BASE,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [{
      path: '/',
      name: 'course',
      component: CoursePage,
      beforeEnter: Guard.auth,
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
      beforeEnter: Guard.guest,
    },
    {
      path: '/reset-password',
      name: 'reset.password',
      component: ResetPasswordPage,
      beforeEnter: Guard.guest,
    },
    {
      path: '/new-password/:token',
      props: true,
      name: 'new.password',
      component: NewPasswordPage,
      beforeEnter: Guard.guest,
    },
    {
      path: '/lesson/:id',
      props: true,
      name: 'lesson',
      component: LessonPage,
      beforeEnter: Guard.auth,
    },
    {
      path: '/quiz/:id',
      props: true,
      name: 'quiz',
      component: QuizPage,
      beforeEnter: Guard.auth,
    },
    {
      path: '/extend-course',
      name: 'course.extend',
      component: Extendcourse,
      beforeEnter: Guard.auth,
    },
    {
      path: '/practicum',
      name: 'practicum',
      component: PracticumPage,
      beforeEnter: Guard.auth,
    },
    {
      path: '/upgrade-course',
      name: 'course.upgrade',
      component: Upgradecourse,
      beforeEnter: Guard.auth,
    },
    {
      path: '/certificate-application',
      props: true,
      name: 'certificate',
      component: CertificateApplication,
      beforeEnter: Guard.auth,
    },
    {
      path: '/profile',
      name: 'user.profile',
      component: ProfilePage,
      beforeEnter: Guard.auth,
    },
    {
      path: '/change-password',
      name: 'user.change.password',
      component: ChangePassword,
      beforeEnter: Guard.auth,
    },
    {
      path: '/library',
      name: 'library',
      component: LibraryPage,
      beforeEnter: Guard.auth,
    },
    {
      path: '/finish',
      name: 'finish',
      component: FinishPage,
      beforeEnter: Guard.auth,
    },
    {
      path: '/marks',
      name: 'marks',
      component: MarksPage,
      beforeEnter: Guard.auth,
    },
    // {
    //   path: '/checkout',
    //   name: 'checkout',
    //   props: true,
    //   component: CheckoutPagePaypal,
    //   beforeEnter: Guard.auth,
    // },
    {
      path: '/checkout',
      name: 'checkout',
      props: true,
      component: CheckoutPageStripe,
      beforeEnter: Guard.auth,
    },
    {
      path: '/certificate-verification',
      name: 'certificate-verification',
      component: CertificateVerification,
      beforeEnter: Guard.guest,
    },

    // 404 - should be last
    { path: '*', name: '404', component: PageNotFound },
    
  ],
});
